import models from "../models.json";

const detail = (m) =>
  [m.age ? `age ${m.age}` : null, m.hair, m.nationality].filter(Boolean).join(", ");

export const galleryFrom = (slug, count = 6) =>
  (models[slug] || [])
    .filter((m) => m.img)
    .slice(0, count)
    .map((m) => ({ img: m.img, caption: `${m.name}, ${detail(m)}` }));

export const leadFrom = (slug) => {
  const first = (models[slug] || []).find((m) => m.img);
  return first ? first.img : "";
};

export const countFrom = (slug) => (models[slug] || []).length;
